module.exports = __webpack_public_path__ + "static/auvlogo2-1c009586e137040c9cdd418d102120dd.jpg";